import ShowToaster from "@/toaster";
import { apiInstances } from "@endpoints/config";

const exportService: any = {
  socket: {
    authorize: async (clientId: string) => {
      try {
        const response = await apiInstances.export
          .get(`socket/authorize?clientId=${clientId}`)
          .json();
        return response;
      } catch (err: unknown) {
        // ShowToaster.error("Something went wrong authorising to socket");
        return [];
      }
    },
  },
  export: {
    xlsx: async (requestPayload: any) => {
      try {
        const response = await apiInstances.export
          .post("export?fileType=xlsx", {
            json: requestPayload,
          })
          .text();
        return response;
      } catch (err: unknown) {
        ShowToaster.error("Something went wrong while exporting excel");
        return [];
      }
    },
    pptx: async (requestPayload: any) => {
      try {
        const response = await apiInstances.data
          .post("dataexport?fileType=pptx", {
            json: requestPayload,
          })
          .text();
        return response;
      } catch (err: unknown) {
        ShowToaster.error("Something went wrong while exporting ppt");
        return [];
      }
    },
  },
  report: {
    xlsx: async (requestPayload: any) => {
      try {
        const response = await apiInstances.export
          .post("export/reportViewExport?fileType=xlsx", {
            json: requestPayload,
          })
          .text();
        return response;
      } catch (err: unknown) {
        ShowToaster.error("Something went wrong while exporting excel");
        return [];
      }
    },
    pptx: async (requestPayload: any) => {
      try {
        const response = await apiInstances.data
          .post("dataexport/reportViewExport?fileType=pptx", {
            json: requestPayload,
          })
          .text();
        return response;
      } catch (err: unknown) {
        ShowToaster.error("Something went wrong while exporting ppt");
        return [];
      }
    },
  },
};

export default exportService;
